<div
  id="seletorApp"
  class="centered"
>
</div>
